export default ((...classNames) => classNames.filter(name => typeof name === 'string').join(' ').replace(/ +/g, ' ').trim());